import React, { useState } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { BaseServiceComponentProps } from '@/pages/benchmark/types/commom';
import { useParams } from 'umi';
import moment from 'moment';
import { TComponentMetric } from '../ProfitDistributionCard';

export interface IRollingRetentionServiceProps
  extends BaseServiceComponentProps {
  metric: string;
  gameCodes: string[];
  dataSource: string;
  nameMap: {
    [key: string]: string;
  };
  [key: string]: any;
}

export default function RollingRetentionService(
  props: IRollingRetentionServiceProps,
) {
  const {
    style,
    className,
    refreshKey,
    interval,
    api,
    children,
    dataKey = 'data',
    filter,
    metric,
    gameCode: propsGameCode,
    nameMap = {},
    extraParams = {},
    ...resetProps
  } = props || {};

  const { gameCode } = useParams() || ({} as any);

  const [componentMetrics, setComponentMetrics] = useState<TComponentMetric[]>(
    [],
  );

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={{ ...props.data }}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        filterLoading={false}
        filterVal={filter}
        formatData={(data: any) => {
          const metrics: TComponentMetric[] = [];
          const newData = data?.dwm_list?.map((item: any) => {
            const { name, value, full_name, share_of_all } = item;
            let fullName = full_name;
            // 名称映射处理
            if (nameMap[fullName]) {
              fullName = nameMap[fullName];
            }
            metrics.push({
              metricKey: name,
              nameEn: fullName,
              nameCn: fullName,
            });
            return {
              key: name,
              value,
              share: share_of_all,
            };
          });
          setComponentMetrics(metrics);
          return newData;
        }}
        beforeRequest={(data) => {
          const { filterVal } = data;
          const { last_date, payType } = filterVal || {};
          // 取T-1天的当月第一天
          const date = moment(last_date || undefined)
            ?.startOf('month')
            ?.format('YYYY-MM-DD');
          const params = {
            game_code: propsGameCode || gameCode,
            filters: {
              zone_list: ['255'],
              market_list: ['255'],
              channel_list: ['255'],
              os_list: ['255'],
              lang_list: ['255'],
            },
            start_time: date,
            end_time: date,
            last_date,
            period: 'monthly',
            by_type: 'category',
            metric: 'share_profit',
            has_top_data: true,
            system: 'studio',
            ...extraParams
          };
          if (payType) {
            // 增加筛选器参数
            params.filters.custom_filters = [
              {
                "key": "payment_type",
                "filter_list": [payType]
              }
            ];
          }
          return params;
        }}
        trackData={[]}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...(resetProps || {}),
            filter,
            componentMetrics,
          }),
        )}
      </Service>
    </div>
  );
}
